import { ShuffleQuestions as ShuffleQuestionsPresenter } from './presenter';
import { getActiveQuiz, getActiveQuizId, setQuizShuffleQuestions, getQuizEntriesByQuizId, connect } from '@instructure/quiz-core';
function mapStateToProps(state) {
  var quizId = getActiveQuizId(state);
  var quizEntries = getQuizEntriesByQuizId(state, quizId);
  return {
    shuffleQuestions: getActiveQuiz(state).shuffleQuestions,
    activeQuizId: quizId,
    quizHasPassage: quizEntries.some(function (entry) {
      return entry.isPassage;
    })
  };
}
export var ShuffleQuestions = connect(mapStateToProps, {
  setQuizShuffleQuestions: setQuizShuffleQuestions
})(ShuffleQuestionsPresenter);
export default ShuffleQuestions;